import { retrieveClaimTypes } from "@/lib/data/requests/matters/claim-type";

export const retrieveClaimTypesQueryOptions = () => ({
  queryKey: ["claimTypes"],
  queryFn: retrieveClaimTypes,
});
